import { LocationType } from '../../../components/locationCard/LocationCard';
import { AnalyticsArticleSearch } from '../interfaces/analyticsArticleSearch';

export function convertToAnalyticsArticleSearch(
  articleSearch: ArticleSearchData,
) {
  const analyticsArticleSearch: AnalyticsArticleSearch = {
    locationName: articleSearch.locationName,
    locationType: articleSearch.locationType,
  };

  return analyticsArticleSearch;
}

export interface ArticleSearchData {
  index?: number;
  keyword?: string;
  locationName: string;
  locationType: LocationType;
  max_price?: number;
  min_price?: number;
  priceSegment?: string;
  project?: string;
  section?: string;
}
